import { Component, OnInit, ViewChild, ViewChildren, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { CustomerService } from 'src/app/modules/core/services/customer.service';
import { CustomerDto, CustomerType } from 'src/app/models/trofaco/customerDto';
import { IsInvalidDirective } from 'src/app/modules/core/directives/is-invalid.directive';
import { NgForm } from '@angular/forms';
import { DuplicateNameConfirmModalComponent } from '../../../customers/customer-details/duplicate-name-confirm-modal/duplicate-name-confirm-modal.component';

@Component({
  selector: 'app-create-customer-modal',
  templateUrl: './create-customer-modal.component.html',
  styleUrls: ['./create-customer-modal.component.css']
})
export class CreateCustomerModalComponent implements OnInit {
    @ViewChild('customerModal', { static: false }) customerModal: ModalDirective;
    @ViewChild(NgForm, {static: true}) form: NgForm;
    @ViewChild(DuplicateNameConfirmModalComponent, { static: false }) confirmDuplicateName: DuplicateNameConfirmModalComponent;

    customersName: string[];

    constructor(private customerService: CustomerService) { }

    @Input()
    countries: string[];

    async ngOnInit() {
        this.customersName = await this.customerService.getCustomersName();
    }

    show() {
        this.isInvalidDirectives.forEach(x => {
            if (x.controlName == 'name' || x.controlName == 'country') x.removeInvalidClass();
        });
        this.customerModal.show();
    }

    cancel() {
        this.customerModal.hide();
        this.markClean();
    }

    @Output()
    onAddedCustomer = new EventEmitter<CustomerDto>();

    customer: CustomerDto = { certificates: [], customerType: CustomerType.B2C };
    @ViewChildren(IsInvalidDirective) isInvalidDirectives: IsInvalidDirective[];
    async save() {
        this.isInvalidDirectives.forEach(x => {
            if (x.controlName == 'name' || x.controlName == 'country') x.updateShowValid();
        });

        if (this.isInvalidDirectives.some(value => value.isInvalid)) return;

        const newCustomerName = this.customer.name.trim().toLocaleLowerCase();

        let isDuplicateName = this.customersName.some((element) => {
            const customerName = element.trim().toLocaleLowerCase();
            return customerName === newCustomerName;
        });

        if (!isDuplicateName) {
            this.customersName.push(newCustomerName);
            this.execute();
            this.customerModal.hide();
        } else {
            this.customerModal.hide();
            let result = await this.confirmDuplicateName.showAwait();
            if (result) 
                this.execute();
            else 
                this.markClean();
        }
    }


    async execute() {
        let id = await this.customerService.create(this.customer);
        this.customer.id = id;
        this.onAddedCustomer.emit({ ...this.customer });
        this.markClean();
    }

    markClean() {
        this.customer = { certificates: [], customerType: CustomerType.B2C };
        this.form.control.markAsPristine();
        this.form.control.markAsUntouched();
    }
}
